import $ from "jquery";

export default function initSOHP() {
    $(".sohp__metros-dropdown").click((event) => {
        $(event.currentTarget).toggleClass("sohp__metros-dropdown--active");
    });

    $(".sohp__quotes").slick({
        arrows: false,
        dots: true,
        dotsClass: "sohp__slick-dots",
        autoplay: true,
        autoplaySpeed: 8000,
    });

    $(".sohp__jobs-cards").slick({
        arrows: false,
        dots: true,
        infinite: false,
        slidesToShow: 1,
        dotsClass: "sohp__slick-dots",
        variableWidth: true,
    });

    $(".job-card--new:not(:last-child)").on("click", (event) => {
        event.preventDefault();

        setTimeout(() => {
            window.location.href = $(event.currentTarget).find("a").prop("href");
        }, 0);
    });
}
